import * as React from 'react';
import { styled } from '@glitz/react';
import { registerComponent, useMatchLargeViewport } from '@avensia/excite';

export const SpacerBlock = registerComponent<NordicNest.Api.SpacerBlock>(({ desktopHeight, mobileHeight }) => {
  const isLargeViewport = useMatchLargeViewport();

  return <styled.Div css={{ height: isLargeViewport ? desktopHeight : mobileHeight }} />;
});
